import { createContext, useContext, useState, ReactNode } from 'react';

interface ColonyContextType {
  activeColonyId: string | null;
  setActiveColonyId: (id: string | null) => void;
}

const ColonyContext = createContext<ColonyContextType | undefined>(undefined);

export const ColonyProvider = ({ children }: { children: ReactNode }) => {
  const [activeColonyId, setActiveColonyId] = useState<string | null>(null);

  return (
    <ColonyContext.Provider value={{ activeColonyId, setActiveColonyId }}>
      {children}
    </ColonyContext.Provider>
  );
};

export const useColonyContext = () => {
  const context = useContext(ColonyContext);
  if (context === undefined) {
    throw new Error('useColonyContext must be used within a ColonyProvider');
  }
  return context;
};
